import { render } from "./SkippedList.vue?vue&type=template&id=dd2a9a5a&scoped=true"
import script from "./SkippedList.vue?vue&type=script&lang=js"
export * from "./SkippedList.vue?vue&type=script&lang=js"

import "./SkippedList.vue?vue&type=style&index=0&id=dd2a9a5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd2a9a5a"

export default script